// extracted by mini-css-extract-plugin
export default {"wrap":"yr-z","logoContainer":"zr-z","brandImg":"Ar-z","logoImg":"Br-z","logoButton":"Cr-z"};